import React from "react";

const MessageFatsuSkeleton: React.FC = () => {
  return (
    <div>
      <div className="h-14 max-sm:h-8 max-sm:w-full w-96 max-md:w-56 skeleton"></div>
      <div className="flex max-md:block justify-start max-md:grid-cols-1">
        <div className="max-w-[315px] max-h-[500px] min-h-[500px] size-full max-sm:mx-auto">
          <div className="max-h-[500px] min-h-[500px] size-full skeleton"></div>
        </div>

        <div className="w-3/4 max-md:w-full my-4">
          <div className="bg-[#3b23b344]">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((item) => {
              return (
                <div
                  key={item}
                  className="skeleton w-full h-6 my-5"
                ></div>
              );
            })}
          </div>
          <div className="max-h-[300px] min-h-[300px] size-full">
            <div className="max-h-[300px] min-h-[300px] size-full skeleton"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MessageFatsuSkeleton;
